(() => {
  class KbiteNotifyButton {
    constructor(container) {
      this.container = container;
      this.form = container.closest('form');
      this.variants = this.getVariants();

      this.update = this.update.bind(this);
      this.updateAfterVariantChange = this.updateAfterVariantChange.bind(this);

      this.listen();
      this.update();
    }

    getVariants() {
      const script = this.form?.querySelector('[data-kbite-variant-state-json]');

      try {
        return JSON.parse(script?.textContent || '{}');
      } catch (error) {
        console.warn('KBite variant data is invalid:', error);
        return {};
      }
    }

    getSelectedVariant() {
      const variantId = this.form?.querySelector('[name="id"]')?.value;

      return this.variants[variantId];
    }

    isSoldOut() {
      return this.getSelectedVariant()?.available === false;
    }

    show() {
      this.container.hidden = false;
      this.container.style.display = '';
      this.container.setAttribute('aria-hidden', 'false');
    }

    hide() {
      this.container.hidden = true;
      this.container.style.display = 'none';
      this.container.setAttribute('aria-hidden', 'true');
    }

    update() {
      if (this.isSoldOut()) {
        this.show();
        return;
      }

      this.hide();
    }

    updateAfterVariantChange() {
      requestAnimationFrame(this.update);
    }

    listen() {
      this.form?.addEventListener('change', this.updateAfterVariantChange);
      window.addEventListener('load', this.update);
    }
  }

  const startKbiteNotifyButtons = () => {
    document.querySelectorAll('[data-kbite-notify-container]').forEach((container) => {
      if (container.dataset.kbiteNotifyReady === 'true') return;

      container.dataset.kbiteNotifyReady = 'true';
      new KbiteNotifyButton(container);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startKbiteNotifyButtons);
  } else {
    startKbiteNotifyButtons();
  }

  document.addEventListener('shopify:section:load', startKbiteNotifyButtons);
})();
